import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import "./Capacity.css";

const CapacityHero = () => {
  const navigate = useNavigate();

  return (
    <section className="capacity-hero">
      <h1 className="capacity-hero-title">
        Capacity Planning
      </h1>

      <p className="capacity-hero-desc">
        JIVIEWS enables quick re-planning and redeployment to handle last-minute
        changes efficiently, ensuring smooth operations with minimal downtime.
      </p>

      <motion.button
        className="capacity-hero-btn"
        whileHover={{
          scale: 1.08,
          backgroundColor: "#ffffff",
          color: "#000000",
          boxShadow: "0 0 20px rgba(255, 255, 255, 0.6)",
        }}
        whileTap={{ scale: 0.95 }}
        transition={{ duration: 0.3, ease: "easeOut" }}
        onClick={() => navigate("/schedule-a-demo")}
      >
        Schedule a Demo
      </motion.button>
    </section>
  );
};

export default CapacityHero;
